import { render, staticRenderFns } from "./SchoolSettings.vue?vue&type=template&id=f855e7c0&scoped=true&"
import script from "./SchoolSettings.ts?vue&type=script&lang=ts&"
export * from "./SchoolSettings.ts?vue&type=script&lang=ts&"
import style0 from "@/views/School/school.scss?vue&type=style&index=0&id=f855e7c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f855e7c0",
  null
  
)

export default component.exports